/* tslint:disable */
/* eslint-disable */
/**
 * Animare Management API
 * This API provides methods for viewing and modifying animare database data for authorities. 
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Criteria for professional activity search
 * @export
 * @interface ProfessionalActivitySearchDto
 */
export interface ProfessionalActivitySearchDto {
    /**
     * Municipality code.
     * @type {string}
     * @memberof ProfessionalActivitySearchDto
     */
    municipalityCode: string;
    /**
     * Minimum registered alive animals count
     * @type {number}
     * @memberof ProfessionalActivitySearchDto
     */
    minimumRegisteredAnimals: number;
}

/**
 * Check if a given object implements the ProfessionalActivitySearchDto interface.
 */
export function instanceOfProfessionalActivitySearchDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "municipalityCode" in value;
    isInstance = isInstance && "minimumRegisteredAnimals" in value;

    return isInstance;
}

export function ProfessionalActivitySearchDtoFromJSON(json: any): ProfessionalActivitySearchDto {
    return ProfessionalActivitySearchDtoFromJSONTyped(json, false);
}

export function ProfessionalActivitySearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfessionalActivitySearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'municipalityCode': json['municipalityCode'],
        'minimumRegisteredAnimals': json['minimumRegisteredAnimals'],
    };
}

export function ProfessionalActivitySearchDtoToJSON(value?: ProfessionalActivitySearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'municipalityCode': value.municipalityCode,
        'minimumRegisteredAnimals': value.minimumRegisteredAnimals,
    };
}

